/**
 * Tokens de estilo de los Excel "presentables" (Inventario valorizado,
 * resumen de Tesorería). Salen del archivo que armó el cliente el
 * 2026-09-04 y que pidió usar como formato: si se toca un color o un
 * formato numérico, se toca acá y las dos planillas siguen siendo la misma
 * familia visual.
 *
 * Los exports viejos (Ventas, movimientos de Tesorería) siguen con
 * `downloadXlsx` pelado; esto es sólo para los dos reportes con diseño.
 */

export const XLSX_FONT = 'Arial';

export const XLSX_COLOR = {
  texto: 'FF1F2937',
  gris: 'FF5B6675',
  azul: 'FF2563EB',
  ambar: 'FFB45309',
  blanco: 'FFFFFFFF',
  borde: 'FFBFC8D4',
} as const;

export const XLSX_FILL = {
  /** Fondo de las tarjetas y de la tabla de resumen. */
  suave: 'FFF4F6F9',
  /** Encabezado de tabla claro. */
  encabezado: 'FFEEF1F5',
  /** Fila de totales. */
  total: 'FFE2E8F0',
  /** Zebra de las filas de datos. */
  zebra: 'FFF5F7FA',
  /** Columnas finales destacadas (Stock total / Sin vender). */
  destacado: 'FFF1F5F9',
  /** Banda de encabezado agrupado. */
  oscuro: 'FF1F2937',
} as const;

/**
 * Importes redondeados a la unidad y con guion en el cero: una planilla de
 * decisión se lee por orden de magnitud, y una grilla llena de "$0,00" tapa
 * los números que importan. El dato subyacente conserva los decimales.
 */
export const FMT_MONEDA = '$#,##0;"-$"#,##0;–';
export const FMT_CANTIDAD = '#,##0;-#,##0;–';
export const FMT_PORCENTAJE = '0.0%';

/** Borde fino en el gris de la paleta, para armar `border` sin repetirlo. */
export const bordeFino = { style: 'thin' as const, color: { argb: XLSX_COLOR.borde } };

export function fill(argb: string) {
  return { type: 'pattern' as const, pattern: 'solid' as const, fgColor: { argb } };
}

export function fuente(opts: {
  size?: number;
  bold?: boolean;
  color?: string;
} = {}) {
  return {
    name: XLSX_FONT,
    size: opts.size ?? 10,
    bold: opts.bold ?? false,
    color: { argb: opts.color ?? XLSX_COLOR.texto },
  };
}
